// MIME types are like file extensions for the internet
// these are the allowed file types where we upload documents and images
// see https://www.iana.org/assignments/media-types/media-types.xhtml for all types
// see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for common types
// MIME types are one single string separated by commas, as seen below.
// NOTE: application/octet-stream can be any file and should usually not be allowed.
// normal files may be seen as application/octet-stream if the size of the document is bigger than the post-size
export default {
    data () {
        return {
            documentMimeTypes: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/gzip,' +
                'application/vnd.ms-powerpoint,application/vnd.rar,application/rtf,application/vnd.oasis.opendocument.presentation,' +
                'application/vnd.oasis.opendocument.text,application/vnd.openxmlformats-officedocument.presentationml.presentation,' +
                'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet,application/x-tar,' +
                'application/zip,application/x-7z-compressed,application/x-bzip,application/x-bzip2,application/x-7z-compressed,application/x-zip-compressed' +
                'image/gif,image/jpeg,image/png,image/jpg,image/tiff,' +
                'audio/mpeg,audio/wav,audio/webm,' +
                'video/mpeg,video/webm,video/mp4,video/x-msvideo,' +
                'text/csv,text/plain',
            imageMimeTypes: 'image/png,image/jpeg,image/jpg'
        }
    },
};